import { render, staticRenderFns } from "./menu-compo-list.vue?vue&type=template&id=68014964"
import script from "./menu-compo-list.vue?vue&type=script&lang=ts"
export * from "./menu-compo-list.vue?vue&type=script&lang=ts"
import style0 from "./menu-compo-list.vue?vue&type=style&index=0&id=68014964&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68014964')) {
      api.createRecord('68014964', component.options)
    } else {
      api.reload('68014964', component.options)
    }
    module.hot.accept("./menu-compo-list.vue?vue&type=template&id=68014964", function () {
      api.rerender('68014964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/menu-compo-list.vue"
export default component.exports